<template>
  <div
    :class="inline ? 'owal form inline field' : 'owal form field'"
  >
    <label
      v-if="label"
      class="owal form field label"
    >
      {{ label }}
    </label>

    <!-- Select -->
    <select
      :multiple="multiselect"
      :class="classesForSelectField"
      :required="required"
      @change="setValue($event.target.selectedOptions)"
    >
      <option
        v-if="!multiselect"
        disabled
        value=""
        label="Please select one"
        selected
      />
      <option
        v-for="option in options"
        :key="option.identifier"
        :label="option.name"
        :value="option.value"
      />
    </select>
  </div>
</template>

<script>
import { CollectionInput } from './mixins'

export default {
  name: 'OwalSelectInput',
  mixins: [CollectionInput],
}
</script>

<style scoped>
.owal {
  font-family: 'Lato', 'Avenir';
}
.owal.form.inline.field {
  display: inline-flex;
  flex-direction: column;
  padding: 0.3975rem;
  margin: 0.3975rem;
  box-sizing:border-box;
}

.owal.form.field.label {
  margin-left: 1rem;
  margin-bottom: 0.53rem;
  font-weight: normal;
  font-size: 14px;
  color: #475669;
  letter-spacing: 0;
}

.owal.form.inline.field .owal.text.input {
  width: 25rem;
}

.owal.checkboxes.container {
  display: flex;
  flex-direction: row;
  padding: 1.14rem 0.5rem;
  background: #F3F4F5;
  border: 1px solid #979797;
  border-radius: 8px;
}

.owal.checkboxes.column {
  display: flex;
  flex-direction: column;
}

.owal.checkboxes.row {
  display: flex;
  flex-direction: row;
}

/* Hide radio buttons */
[type="radio"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px; margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* Use the span to redraw fake radios that look nice. */
[type="radio"] + span::before {
  content: '';
  display: inline-block;
  width: 1.31rem;
  height: 1.31rem;
  vertical-align: -0.25rem;
  border-radius: 1em;
  background: #EFF2F7;
  border: 1px solid #979797;
  box-shadow: inset 0 0 0 2px #FFFFFF;
  margin-right: 0.75rem;
  transition: 0.5s ease all;
}

[type="radio"]:checked + span::before {
  background: #475669;
  border: 1px solid #979797;
  box-shadow: inset 0 0 0 2px #FFFFFF;
}

.owal.radio.button {
  font-size: 14px;
  color: #475669;
  height: 1.63rem;
  margin: 0.22rem .66rem;
}

.owal.file.input.container {
  background: #F3F4F5;
  border: 1px solid #979797;
  border-radius: 8px;
  height: 10.5rem;
  width: 10.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-image: url('../assets/img/watermark@3x.png');
  background-size: 4.25rem 4.25rem;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: 2.5rem;

  transition: all 0.2s ease;
}

.owal.file.input input {
  visibility: hidden;
}

.owal.file.input.image.container {
  background: #F3F4F5;
  flex-shrink: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 0.25rem;
}

.owal.file.input.image.preview {
  max-width: 10rem;
  max-height: 10rem;
}

/* .owal.file.input:after {
  display: block;
  height: 10.5rem;
  width: 10.5rem;
} */

.owal.file.input.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.75rem;
  font-size: 12px;
  color: #8492A6;
  opacity: 0.5;
  transition: all 0.2s ease;
}

.owal.file.input.container:hover {
  background-size: 5rem 5rem;
  background-position-y: 2.25rem;
}

.owal.file.input.container:hover .owal.file.input.banner {
  opacity: 1;
}

</style>
